<template>
    <div>
        <el-form
            :model="ruleForm"
            status-icon
            :rules="rules2"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
        >
            <el-form-item prop="name" label="用户名" style="display:none;">
                <el-input v-model="ruleForm.name" auto-complete="off" placeholder="请输入用户名/手机号"></el-input>
            </el-form-item>
            <el-form-item prop="old_password" label="旧密码">
                <el-input
                    type="password"
                    v-model="ruleForm.old_password"
                    auto-complete="off"
                    placeholder="输入旧密码"
                ></el-input>
            </el-form-item>
            <el-form-item prop="password" label="新密码">
                <el-input
                    type="password"
                    v-model="ruleForm.password"
                    auto-complete="off"
                    placeholder="输入密码"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button
                    type="primary"
                    @click="doLogin('ruleForm')"
                    style="width:200px;margin-left:-100px!important;"
                >确认修改</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
// import { nextTick } from 'q'
// import axios from "axios";
import { mapMutations } from 'vuex'
export default {
    name: 'Forgetpass',
    data() {
        return {
            ruleForm: {
                password: '',
                name: '',
                old_password: ''
            },
            rules2: {
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, message: '请至少输入6位数密码', trigger: 'blur' }
                ],
                old_password: [
                    {
                        required: true,
                        message: '请输入旧密码',
                        trigger: 'blur'
                    },
                    { min: 6, message: '请输入旧密码', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.ruleForm.name = JSON.parse(localStorage.getItem('user')).name
    },
    methods: {
        // 修改密码
        doLogin() {
            let data = {
                name: this.ruleForm.name,
                password: this.ruleForm.password,
                old_password: this.ruleForm.old_password,
                ifEncrypt: true,
                platformId: localStorage.getItem('datas')
            }
            var qs = require('qs')
            this.$axios
                .post(
                    this.$managePath + '/yunapi/user_api/update_user_password',
                    qs.stringify(data),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }
                )
                .then(res => {
                    if (res.data.status == 0) {
                        this.$router.push('/student/login')
                    }
                })
                .catch(res => {
                    console.log('err')
                })
        },
        focusToError() {
            setTimeout(() => {
                this.errorStepPage('active0', 0)
                this.errorStepPage('active1', 1)
                this.errorStepPage('active2', 2)
            }, 1)
            return false
        },
        // 初始化校验不通过跳转情况
        errorStepPage: function(activeClassName, page) {
            var errorStep = document.getElementsByClassName(activeClassName)
            var Error = errorStep[0].getElementsByClassName('is-error')
            if (Error.length > 0) {
                this.active = page
                if (Error[0].querySelector('textarea') != null) {
                    Error[0].querySelector('textarea').focus()
                } else {
                    Error[0].querySelector('input').focus()
                }
                return
            }
        }
    }
}
</script>

<style scoped>
.el-form-item {
    text-align: center;
}
.code >>> .el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.code button {
    margin-left: 20px;
    width: 140px;
    text-align: center;
}
.el-button--primary:focus {
    background: #409eff;
    border-color: #409eff;
    color: #fff;
}
.el-form-item__content:last-child {
    margin-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/student/Forgetpass.vue